import { ComponentProps } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import styles from './loadingSpinner.module.scss';

const loadingSpinnerClass = cva(styles.loadingSpinner, {
  variants: {
    size: {
      small: styles.small,
      medium: styles.medium,
      large: styles.large
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});

type LoadingSpinnerProps = ComponentProps<'span'> &
  VariantProps<typeof loadingSpinnerClass> & {
    stretch?: boolean;
  };

export default function LoadingSpinner({
  className,
  size,
  stretch = false,
  ...props
}: LoadingSpinnerProps) {
  const renderLoadingSpinner = () => {
    return (
      <span className={loadingSpinnerClass({ className, size })} {...props} />
    );
  };

  if (stretch) {
    return (
      <div className={styles.stretchContainer}>{renderLoadingSpinner()}</div>
    );
  }

  return renderLoadingSpinner();
}
